export default __webpack_public_path__ + "static/media/MetricUp.536ff77e.svg";